import { Helpers } from '../../helpers';
import { IResourceCostCodeCostType } from '../../interfaces/iresource-cost-code-cost-type';
import { CostCodeCostTypeProjectCombination } from '../cost-code-cost-type-project-combination';
import { ProjectType } from '../project-type';
import { ScheduleActivityCostCodeCostType } from '../schedule-activity-cost-code-cost-type';

export class ResourceCostCodeCostTypeBase {
  ResourceCostCodeCostTypeId: number;
  CostCodeCostTypeProjectCombinationId: number | null;
  ProjectTypeId: number | null;
  CostCodeCostTypeValue: string | null;
  CostCodeCostTypeName: string | null;
  Quantity: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScheduleActivityCostCodeCostTypes_ResourceCostCodeCostType?: Array<ScheduleActivityCostCodeCostType> | null;
  CostCodeCostTypeProjectCombination?: CostCodeCostTypeProjectCombination;
  ProjectType?: ProjectType;

  constructor(item?: IResourceCostCodeCostType) {
    if (item) {

      this.ResourceCostCodeCostTypeId = item.ResourceCostCodeCostTypeId;
      this.CostCodeCostTypeProjectCombinationId = item.CostCodeCostTypeProjectCombinationId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.CostCodeCostTypeValue = item.CostCodeCostTypeValue;
      this.CostCodeCostTypeName = item.CostCodeCostTypeName;
      this.Quantity = item.Quantity;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScheduleActivityCostCodeCostTypes_ResourceCostCodeCostType = Helpers.createClassArray(ScheduleActivityCostCodeCostType, item.ScheduleActivityCostCodeCostTypes_ResourceCostCodeCostType);
      this.CostCodeCostTypeProjectCombination = new CostCodeCostTypeProjectCombination(item.CostCodeCostTypeProjectCombination);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}